export async function yieldToMainThread(): Promise<void> {
    return new Promise( ( resolve ) => {
        window.setTimeout( resolve, 0 );
    } );
}
